﻿import { determineFullTradeData, returnAllTradeDetailsFromGenericParams, returnOPLegFormThisTrade, returnRPLegFromThisTrade } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import React from "react";
import { returnFeeValueFormatted } from "../cellRenderers/ExecutionFeeCellRenderer";
import { determineCurrencySymbol } from "@/lib/currencySymbolHelper";
import tradeDataStore from "@/store/tradeDataStore";
import { statusAtAffirmedRange } from "../colDefs/colDefsShared";

// Shows the final transaction fee (direction + amount) once both ES and ER reach Affirmed”

const CashDealerTooltip = (params: any) => {
  const data = params.data;
  const fullTradeData = determineFullTradeData(params);

  const currentTradeData = tradeDataStore((state) => state.tradeData);
  const thisTrade =
    currentTradeData.find((trade) => trade.esid == fullTradeData.esid) ??
    fullTradeData;
  if (!thisTrade) return null;

  //Determine trade details
  const { isOp, isOutright, isLeg, isER } =
    returnAllTradeDetailsFromGenericParams(params);
  const helperObject = { params, thisTrade, isOp, isER, isOutright, isLeg };
  const thisLeg = isOp
    ? returnOPLegFormThisTrade(helperObject)
    : returnRPLegFromThisTrade(helperObject);

  
    //Determine currency symbol
  const currencySymbol = determineCurrencySymbol({
    thisTrade,
    thisLeg,
    isLeg,
    isER,
    isOutright,
  });


  
  //Tooltip logic for blocks
  if(isLeg && statusAtAffirmedRange.includes(thisTrade.status) && statusAtAffirmedRange.includes(params.data.statusER)) {
    // fees can be an empty array on affirmed legs with no fee yet; guard before deref.
    const fees = thisLeg?.fees?.[0];
    if (!fees) return null;
    return (
      <div className="bg-gray-300 px-1 shadow-lg dark:bg-[#171717]">
        <div> Quoted Amount:</div>
        Dealer {fees.transactionFeeDirection} {currencySymbol}{returnFeeValueFormatted(fees.transactionFee ?? undefined)}
      </div>
    )
    
  }


  //Tooltip logic for ER
  if (statusAtAffirmedRange.includes(thisTrade.status) && statusAtAffirmedRange.includes(params.data.status)) {
    // fees can be an empty array on affirmed ERs with no fee yet; guard before deref.
    const fees = isOutright ? data.legs?.[0]?.fees?.[0] : data?.fees?.[0];
    if (!fees) return null;
          return (
        <div className="bg-gray-300 px-1 shadow-lg dark:bg-[#171717]">
          <div> Quoted Amount: </div>
          Dealer {fees.transactionFeeDirection} {currencySymbol}{returnFeeValueFormatted(fees.transactionFee ?? undefined)}
        </div>
      );
  }

  return null;
};

export default CashDealerTooltip;

